export const brandingTabs = {
  brandAndImages: 'brandAndImages',
  buttonsAndLinks: 'buttonsAndLinks',
  selectors: 'selectors',
}

export const postMessageTypes = {
  themeUpdate: 'REVENI_THEME_UPDATE',
  previewSection: 'REVENI_PREVIEW_SECTION',
  iframeReady: 'REVENI_IFRAME_READY',
}

export const previewSections = {
  returnsPortal: 'returnsPortal',
  trackingPage: 'trackingPage',
}
